import { render } from "./BlocksEdit.vue?vue&type=template&id=5cdd2a1a&scoped=true"
import script from "./BlocksEdit.vue?vue&type=script&lang=js"
export * from "./BlocksEdit.vue?vue&type=script&lang=js"

import "./BlocksEdit.vue?vue&type=style&index=0&id=5cdd2a1a&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdd2a1a"]])

export default __exports__